/* eslint-disable import/prefer-default-export */
import axios from 'axios';

export const profileAsync = async () => {
  const res = await axios({
    url: 'api/user/personal-info',
    method: 'GET',
  });
  return res.data;
};
